import { Card, Statistic, Typography } from "antd";
import type { ReactNode } from "react";

export type DashboardStatCardProps = {
  label: string;
  value: number;
  icon: ReactNode;
  delta: string;
  tone: string;
  loading?: boolean;
};

export function DashboardStatCard({
  label,
  value,
  icon,
  delta,
  tone,
  loading = false,
}: DashboardStatCardProps) {
  return (
    <Card
      bordered={false}
      style={{ width: "100%", height: "100%" }}
      bodyStyle={{
        padding: "20px 24px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Statistic
        title={label}
        value={value}
        loading={loading}
        groupSeparator=" "
        prefix={
          <span
            style={{
              display: "inline-flex",
              verticalAlign: "-4px",
              marginRight: 10,
            }}
          >
            {icon}
          </span>
        }
        valueStyle={{ fontSize: 30, fontWeight: 600, whiteSpace: "nowrap" }}
      />
      <Typography.Text style={{ fontSize: 13, color: tone, marginTop: "auto" }}>
        {loading ? "\u00a0" : delta}
      </Typography.Text>
    </Card>
  );
}
